module.exports = require("translator");